<template>
  <div class="slide p-0 m-0">
    <div
      class='d-flex flex-column'
      :class="{
        container: !isObserver,
        'container-fluid': isObserver,
        'px-md-5': !isObserver && !forceFullSizeSlide,
        'pt-sm-3': !isObserver && !forceFullSizeSlide,
        'pt-md-5': !isObserver && !forceFullSizeSlide,
        'p-5': !forceFullSizeSlide,
        'p-0': isObserver && forceFullSizeSlide,
      }"
    >
      <div class="card border-0 rounded-0 shadow-lg">
        <div class="card-header d-flex flex-column flex-column-reverse flex-md-row align-items-stretch bg-theme rounded-0 border-bottom align-items-sm-center p-0">
          <div v-if="election.theme.logo" class="bg-light p-3 align-self-stretch d-flex align-items-center">
            <img :src="election.theme.logo" style="max-height:50px;max-width:100%" />
          </div>
          <div class="d-flex flex-grow-1 w-100 align-items-center justify-content-between p-3">
            <h3 class="mb-0">{{election.title[firstAvailableLocale]}}</h3>
            <LocaleSwitcher v-if="showLocaleSwitcher"/>
          </div>
        </div>
        <div
          class="card-body p-3 d-flex flex-column"
          :class="isObserver && forceFullSizeSlide ? 'px-qhd-5 overflow-hidden pb-0' : 'px-md-5 py-lg-5'"
          :style="isObserver && forceFullSizeSlide ? 'height: calc(100vh - 4.75rem);' : ''"
        >
          <template v-if="slide.type === 'Slides::PresentationSlide'">
            <template v-if="slide.layout === 'header_with_text'">
              <header class="h1 text-center">{{title}}</header>
              <div class="lead" v-html="description"></div>
            </template>
            <template v-else-if="slide.layout === 'header_with_image'">
              <header class="h1 text-center">{{title}}</header>
              <img class="img-fluid align-self-center" :src="image" :alt="description"/>
            </template>
            <div v-else-if="slide.layout === 'single_image'" class="text-center">
              <img class="img-fluid align-self-center" :src="image" :alt="description"/>
            </div>
          </template>
          <template v-if="isBallot">
            <StickyAlerts>
              <template #before>
                <transition name="slidein" mode="out-in">
                  <Ballot v-if="isBallot" :ballot="slide"/>
                </transition>
              </template>
            </StickyAlerts>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import LocaleSwitcher from "../shared/LocaleSwitcher.vue";
    import Ballot from './Ballot.vue'
    import StickyAlerts from "../shared/StickyAlerts.vue"

    export default {
        components: {
            StickyAlerts,
            LocaleSwitcher,
            Ballot,
        },
        name: "Slide",
        props: {
            active: {
                type: Boolean,
                required: false,
                default: false
            },
            slide: {
                type: Object,
                required: false,
                default: ()=>{
                    return {type: 'none'}
                }
            },
            showLocaleSwitcher: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            ...mapState(['slideOffset', 'election']),
            ...mapGetters(['firstAvailableLocale', 'handRaiseLiveResults', 'forceFullSizeSlide']),
            title(){
                return this.slide.title[this.firstAvailableLocale];
            },
            description(){
                return this.slide.description[this.firstAvailableLocale];
            },
            image(){
                return this.slide.image;
            },
            isBallot(){
                return this.slide.type === 'Slides::BallotSlide';
            },
            isObserver(){
              if (window.location.href.search(/\observe\b/) >= 0) {
                return true;
              }
            },
        },
        mounted(){
            // $(document).ready(function(){
            //     $('html,body').stop(true, false).animate({scrollTop: document.body.scrollHeight-window.innerHeight}, (document.body.scrollHeight-window.innerHeight)*50)
            // });
        }
    }
</script>
